// extracted by mini-css-extract-plugin
export default {"burger":"burger_burger__WBtlp","line":"burger_line__T0b1C","burger--active":"burger_burger--active__5g1Mr"};